export default {
    items: [
        // dag 1
        {
            files: ['delier_0_nacht_ochtend_blinds-open.mp4'],
            markers: [
                {time: 0, type: 'message', param: 'dag0.video.ochtend'},
                {time: 8, type: 'tip', param: 'algemeen.tutorial.tip1.text'},
            ]
        },
        // dag 2
        {
            files: [
                'delier_1_nacht_ochtend_blinds-dicht.mp4',
                'delier_1_nacht_ochtend_blinds-dicht_ma.mp4',
            ],
            markers: [
                {time: 0, type: 'message', param: 'dag1.video.ochtend1'},
                {time: 25, type: 'message', param: 'dag1.video.ochtend2'},
            ]
        },
        // dag 3 groen
        {
            files: [
                'delier_2_nacht_ochtend_blinds-dicht.mp4',
                'delier_2_nacht_ochtend_blinds-dicht_ma.mp4',
                'delier_2_nacht_ochtend_blinds-dicht_di.mp4',
            ],
            markers: [
                {time: 0, type: 'message', param: 'dag2.video.ochtend1'},
                {time: 34, type: 'message', param: 'dag2.video.ochtend2'},
            ]
        },
        // dag 3 oranje
        {
            files: [
                'delier_3_nacht_ochtend_blinds-dicht.mp4',
                'delier_3_nacht_ochtend_blinds-dicht_ma.mp4',
                'delier_3_nacht_ochtend_blinds-dicht_di.mp4',
            ],
            markers: [
                {time: 0, type: 'message', param: 'dag2.video.ochtend1'},
                {time: 35, type: 'message', param: 'dag2.video.ochtend2'},
            ]
        },
        // dag 3 rood
        {
            files: [
                'delier_4_nacht_ochtend_blinds-dicht.mp4',
                'delier_4_nacht_ochtend_blinds-dicht_ma.mp4',
                'delier_4_nacht_ochtend_blinds-dicht_di.mp4',
            ],
            markers: [
                {time: 0, type: 'message', param: 'dag2.video.ochtend1'},
                {time: 48, type: 'message', param: 'dag2.video.ochtend2'},
            ]
        },
        // dag 4 groen
        {
            files: [
                'delier_5_nacht_ochtend_blinds-dicht.mp4',
                'delier_5_nacht_ochtend_blinds-dicht_ma.mp4',
                'delier_5_nacht_ochtend_blinds-dicht_di.mp4',
                'delier_5_nacht_ochtend_blinds-dicht_wo.mp4',
            ],
            markers: [
                {time: 0, type: 'message', param: 'dag3.video.ochtend1'},
                {time: 34, type: 'message', param: 'dag3.video.ochtend2'},
            ]
        },
        {
            files: [],
            markers: [
                {time: 1, type: 'message', param: 'template'},
            ]
        },
        // dag 4 oranje
        {
            files: [
                'delier_6_nacht_ochtend_blinds-dicht.mp4',
                'delier_6_nacht_ochtend_blinds-dicht_ma.mp4',
                'delier_6_nacht_ochtend_blinds-dicht_di.mp4',
                'delier_6_nacht_ochtend_blinds-dicht_wo.mp4',
            ],
            markers: [
                {time: 0, type: 'message', param: 'dag3.video.ochtend1'},
                {time: 34, type: 'message', param: 'dag3.video.ochtend2'},
            ]
        },
        {
            files: [],
            markers: [
                {time: 1, type: 'message', param: 'template'},
            ]
        },
        // dag 4 rood
        {
            files: [
                'delier_7_nacht_ochtend_blinds-dicht.mp4',
                'delier_7_nacht_ochtend_blinds-dicht_ma.mp4',
                'delier_7_nacht_ochtend_blinds-dicht_di.mp4',
                'delier_7_nacht_ochtend_blinds-dicht_wo.mp4',
            ],
            markers: [
                {time: 0, type: 'message', param: 'dag3.video.ochtend1'},
                {time: 37, type: 'message', param: 'dag3.video.ochtend2'},
            ]
        },
        {
            files: [],
            markers: [
                {time: 1, type: 'message', param: 'template'},
            ]
        }
    ]
};